import { SeriesListInterface, SurveyInterface, SurveyState } from '../../models/state';
import { actionTypes } from '../actions/survey';

const initialState: SurveyState = {
  survey: {} as SurveyInterface,
  fieldTypes: [],
  columnTypesTable: [],
  columnTypesMatrice: [],
  languages: [],
  roles: [],
  seriesList: [],
  seriesListCount: 0,
  surveySeries: {} as SeriesListInterface & { surveys: SurveyInterface[] },
  emailTypes: [],
};
const surveyReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_SURVEY_SUCCESS: {
      return {
        ...state,
        survey: action.payload,
      };
    }
    case actionTypes.GET_STATIC_VALUES_SUCCESS: {
      return {
        ...state,
        fieldTypes: action.payload.fieldTypes,
        columnTypesTable: action.payload.columnTypesTable,
        columnTypesMatrice: action.payload.columnTypesMatrice,
        languages: action.payload.languages,
        roles: action.payload.roles,
        emailTypes: action.payload.emailTypes,
      };
    }
    case actionTypes.UPDATE_SURVEY_SUCCESS: {
      return {
        ...state,
        survey: action.payload,
      };
    }
    case actionTypes.CREATE_SURVEY_SERIES_SUCCESS: {
      // not used as of now
      const { surveySeries } = action.payload;
      const { seriesList } = state;
      seriesList.unshift(surveySeries);

      return {
        ...state,
        seriesList,
      };
    }
    case actionTypes.GET_SURVEY_SERIES_SUCCESS: {
      return {
        ...state,
        seriesList: action.payload.rows,
        seriesListCount: action.payload.count,
      };
    }
    case actionTypes.GET_SURVEY_SERIES_BY_ID_SUCCESS: {
      return {
        ...state,
        surveySeries: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};

export default surveyReducer;
